import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/revolutionize.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              {" "}
              Why Choose TekRevol for Custom Software Development in San
              Francisco
            </h2>
            <p>
              Selecting the right partner for custom software development is
              critical to your business's success, and TekRevol stands as the
              optimal choice in the vibrant tech landscape of San Francisco. Our
              reputation for excellence is built on a foundation of innovation,
              expertise, and a proven track record of delivering tailored
              software solutions. We pride ourselves on our commitment to
              understanding your unique needs and crafting software that not
              only meets but surpasses your expectations.
            </p>
            <p>
              With TekRevol, you gain a partner dedicated to turning your vision
              into a reality, harnessing the latest technologies to drive your
              business forward.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
